import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations';
import * as Yup from 'yup';
import { AADHAR_VALIDATION, ERROR_MSG } from '../../CommonUtils/contextVariables';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';

export default function AfflFindDupliFaculty() {
    const acYear = sessionStorage.getItem('ac_year');

    const [FacultyData, setFacultyData] = useState([]);
    const [showemptable, setemptable] = useState(false);
    const [status, setStatus] = useState(null);
    function GetFacultyData(aadhar) {
        let url = config.url.API_URL + `getMemAadharData/` + aadhar;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFacultyData(res?.data?.getMemAadharData);
                setStatus(true);
                setemptable(true);
            } else {
                setFacultyData([]);
                setStatus(false);
                setemptable(true)
            }
        });
    }
    const AfflFacDupValidtaion = Yup.object({
        aadhar: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, "Invalid Aadhaar number").nullable(),
    });
    const AflFacDupFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            aadhar: "",
            empId: FacultyData[0]?.emp_id,
            remarks: ""
        },
        validationSchema: AfflFacDupValidtaion,
        onSubmit: (values) => {
            GetFacultyData(values?.aadhar);

        },
    });

    function DeleteEmployeeData(values) {
        if (!values?.remarks) {
            Swal.fire({
                text: 'Please enter remarks before Deleting!',
                icon: 'warning',
                confirmButtonText: 'OK',
                backdrop: false,
            });
            return;
        }
        const { aadhar, ...dataToSend } = values;
        Swal.fire({
            text: 'Are you sure you want to submit?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, submit it!',
            cancelButtonText: 'No, cancel!',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.API_URL}deleteAadharEmployee`;
                CommonAxiosPost(url, dataToSend).then((res) => {
                    if (res?.data?.scode === '01') {
                        successAlertRefresh(res?.data?.sdesc);
                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            }
        });
    }
    return (
        <>
            <CommonFormHeading heading={`Faculty Verification/ Delete - Aadhaar Number Based ${acYear}`} />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={AflFacDupFormik}>
                    <Form onChange={AflFacDupFormik?.handleChange} onSubmit={AflFacDupFormik?.handleSubmit} className="form_adjust">
                        <bie.Row className="px-2 pt-3 mb-3">
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                    <label className='mb-1'>
                                        Enter Aadhaar No:
                                    </label>
                                    <Field type="text" name="aadhar" className="form-control" onKeyPress={(e) => { allowNumbersOnly(e) }}
                                        onPaste={(e) => handlePaste(e)} maxLength={12} onChange={() => { setStatus(true); setemptable(false) }}
                                        value={AflFacDupFormik?.values?.aadhar} />
                                    <ErrorMessage name="aadhar" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                    <button type="submit" className="btn btn-success mt-4">
                                        Submit
                                    </button>
                                </bie.Col>
                            </bie.Row>
                            {status === false && showemptable === true && FacultyData.length === 0 ? (
                                <center className='text-danger h5 pt-5'>***** No Data Found *****</center>
                            ) : (status === true && FacultyData.length > 0 ? (
                                <div className="table-responsive">
                                    <center>
                                        <table className="table table-bordered table-striped table-sm affl-table" role="presentation"
                                            aria-hidden="true">
                                            <tbody>
                                                <tr> <td colSpan={2} style={{ color: "brown", fontWeight: "bold", fontSize: "15px", textAlign: "center", backgroundColor: "#b9ebce" }}>     Details of the Faculty    </td></tr>
                                                <tr>
                                                    <td>Employee Name</td>
                                                    <td>{FacultyData[0]?.emp_name}</td>
                                                </tr>
                                                <tr><td>Employee Aadhar No.</td><td>{FacultyData[0]?.aadhar}</td></tr>
                                                <tr><td>Employee Phone No.</td><td>{FacultyData[0]?.emp_mobileno}</td></tr>
                                                <tr><td>University</td><td>{FacultyData[0]?.ub_name}</td></tr>
                                                <tr><td>College Code</td><td>{FacultyData[0]?.college_code}</td></tr>
                                                <tr><td>College Name</td><td>{FacultyData[0]?.inst_name}</td></tr>
                                                <tr><td>Designation</td><td>{FacultyData[0]?.designation_name}</td></tr>
                                            </tbody>
                                        </table>
                                        <div className="row">
                                            <div className="col-1 label"></div>
                                            <div className="col-3 label">Enter Remarks:</div>
                                            <div className="col-3">
                                                <Field as="textarea" name="remarks" className="form-control" maxLength={350} />
                                                <ErrorMessage name="remarks" component="div" className="text-error" />
                                            </div>
                                            <div className="col-1">
                                                <button type="button" className="badge text-bg-danger rounded mt-2 float-end mb-2" style={{ padding: "10px 20px", fontSize: "15px" }} onClick={() => DeleteEmployeeData(AflFacDupFormik.values)}>
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            ) : null
                            )}
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    );
}

